const Course = () => {
    return (
        <>
            <p className='Help__Subtitle'>Avance general</p>
            <img src='/img/support/help/ztudent/course/1.png' className='Help__Image' />
            <p>¿Qué muestra la opción <span className='Help__Text--Highlight'>Avance general</span>?</p>
            <p>Permite visualizar el progreso global del curso. Aquí se muestra el porcentaje completado en relación con los bloques, temas y actividades realizadas, brindando una visión clara de cuánto has avanzado y lo que falta por completar.</p>

            <p className='Help__Subtitle'>Objetivo general</p>
            <img src='/img/support/help/ztudent/course/2.png' className='Help__Image' />
            <p>¿Qué muestra la opción <span className='Help__Text--Highlight'>Ver objetivo del curso</span>?</p>
            <p>Permite consultar el objetivo principal del curso. Aquí se describe la meta que se busca alcanzar al finalizar el curso, brindando una visión clara del propósito y los aprendizajes esperados.</p>

            <p className='Help__Subtitle'>Buscar Tema</p>
            <img src='/img/support/help/ztudent/course/3.png' className='Help__Image' />
            <p>¿Cómo funciona la opción <span className='Help__Text--Highlight'>Buscar Tema</span>?</p>
            <p>Permite localizar rápidamente un tema por palabras clave. Escribe el dato en el campo de búsqueda y Ztudia mostrará solo los resultados relacionados, ocultando los demás para facilitar el aprendizaje.</p>

            <p className='Help__Subtitle'>Temario</p>
            <img src='/img/support/help/ztudent/course/4.png' className='Help__Image' />
            <p>¿Qué hay en el temario?</p>
            <p>Permite consultar todas las evaluaciones disponibles organizadas por bloque.</p>
            <p>Al abrir un bloque de conocimiento, se muestran los temas que lo conforman. Al ingresar a un tema, se despliegan los instrumentos de aprendizaje, que incluyen: teoría, cuestionario, vídeo y desafío.</p>
            <p>Las evaluaciones solo estarán disponibles si el instructor las ha agendado dentro de las fechas y horarios establecidos.</p>
        </>
    )
}

export { Course };